/** Objeto que contiene información sobre el titular de la póliza. */

import { DataProtection } from '@/modules/common/common/models/MID/DataProtection'
import { UserRoleEnum } from '@/modules/core/models/enums'

export default class ForeignHealthPolicyHolder {
  /** Rol del titular dentro de la póliza. Valores válidos: TA o TN.  */
  role!: UserRoleEnum.HOLDER_INSURED | UserRoleEnum.HOLDER_NOT_INSURED

  /** (String): Nombre del titular. */
  name!: string

  /** (String): Primer apellido del titular. */
  firstSurname!: string

  /** (String): Segundo apellido del titular. */
  secondSurname!: string

  /** (DateTime): Fecha de nacimiento del titular. */
  birthDate!: string

  /** (String): Sexo del titular. */
  sex!: string

  /** (String): Tipo de documento de identidad del titular. */
  documentType!: string

  documentExpirationDate!: string | null

  /** (String): Número de documento de identidad del titular. */
  documentNumber!: string

  /** (String): Nacionalidad del titular. */
  nationality!: string

  /** (String): Correo electrónico del titular. */
  email!: string

  /** (String): Prefijo telefónico del titular. */
  prefix!: string

  /** (Integer): Número de teléfono móvil del titular. */
  mobilePhone!: number

  /** (String): Código postal de la dirección del titular. */
  postalCode!: string

  /** (String): Provincia de la dirección del titular. */
  province!: string

  /** (String): Ciudad de la dirección del titular. */
  city!: string

  /** (String): Tipo de vía de la dirección del titular. */
  streetType!: string

  /** (String): Nombre de la vía de la dirección del titular. */
  street!: string

  /** (Integer): Tipo de vivienda del titular.
   * 1 -> piso
   * 2 -> casa
   */
  houseType!: 1 | 2

  /** (String): Número de vivienda del titular. */
  house!: string

  /** (String): Portal de la dirección del titular. */
  gateway!: string

  /** (String): Escalera de la dirección del titular. */
  stair!: string

  /** (String): Piso de la dirección del titular. */
  floor!: string

  /** (String): Puerta de la dirección del titular. */
  doorway!: string

  /** (String): Resto de la dirección del titular. */
  restAddress!: string

  personType: string | null

  addressNormalice: string | null

  sendPrecontractualDocuments: string | null

  dataProtection: DataProtection | undefined

  constructor(data: any) {
    this.role = data.role
    this.name = data.name
    this.firstSurname = data.firstSurname
    this.secondSurname = data.secondSurname
    this.birthDate = data.birthDate
    this.sex = data.sex
    this.documentType = data.documentType
    this.documentNumber = data.documentNumber
    this.documentExpirationDate = data.documentExpirationDate
    this.nationality = data.nationality
    this.email = data.email
    this.prefix = data.prefix
    this.mobilePhone = data.mobilePhone
    this.postalCode = data.postalCode
    this.province = data.province
    this.city = data.city
    this.streetType = data.streetType
    this.street = data.street
    this.houseType = data.houseType
    this.house = data.house
    this.gateway = data.gateway
    this.stair = data.stair
    this.floor = data.floor
    this.doorway = data.doorway
    this.restAddress = data.restAddress
    this.personType = data.personType
    this.addressNormalice = data.addressNormalice
    this.sendPrecontractualDocuments = data.sendPrecontractualDocuments
    if (data.dataProtection) this.dataProtection = new DataProtection(data.dataProtection)
  }
}
